<template>
  <v-layout row justify-center>
    <v-dialog v-model="value" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card tabindex="0" @keypress.native="onkeypress">
        <v-toolbar dark color="primary">
          <v-btn icon @click.native="closeH" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Transaction History</v-toolbar-title>
        </v-toolbar>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 lg12 v-for="item in data" :key="item.id">
              <v-card :class="item.class" class="card-cst">
                <div class="hoveritem center-middle" :class="item.color"><v-icon class="mr-5px" dark>{{item.icon}}</v-icon><span>{{item.eventType}}</span></div>
                <v-container fluid>
                  <v-layout row wrap>
                    <v-flex xs12 lg12>
                      <div class="tittle">{{item.tittle}}</div>
                      <span class="sub-header"><b>{{item.eventType}}</b> | {{item.eventUser.value}} | {{item.timef}}</span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      require: true
    },
    data: {
      type: [String, Array],
      required: true
    }
  },
  methods: {
    closeH () {
      this.$closeHistory({vueinstance: this, Id: '', Status: false})
    },
    onkeypress (event) {
      // ESC
      if (event.keyCode === 27) {
        this.closeH()
      }
    }
  }
}
</script>
<style scoped>
@media only screen and (max-width: 599px) {
  .card-cst .container{
    padding: 15px !important;
  }
}
.tittle{
  font-size: 16px;
  font-weight: 600;
  color: #424242;
}
.sub-header{
  font-size: 12px;
  color: #9E9E9E;
}
.center-middle{
  display: flex;
  justify-content: center;
  align-items: center;
}
.hoveritem{
    color: #ffffff;
    font-size: 22px;
    font-weight: bold;
    height: 100%;
    opacity: 0;
    width: 0;
    position: absolute;
    /* -webkit-transition: width 0.5s ease-in-out;
    -moz-transition: width 0.5s ease-in-out;
    -ms-transition: width 0.5s ease-in-out;
    -o-transition: width 0.5s ease-in-out;
    transition: width 0.5s ease-in-out; */
}
  /* .card-cst:hover .hoveritem{
    opacity: 1;
    width: 100%;
  } */
  .hoveritem .card-create{
    background : #4CAF50;
  }
  .hoveritem .card-update{
    background: #2196f3;
  }
  .hoveritem .card-delete{
    background: #f44336;
  }
.card-cst{
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-left: 10px solid;
}
  .card-create{
    border-color: #4CAF50;
  }
  .card-update{
    border-color: #2196f3;
  }
  .card-delete{
    border-color: #f44336;
  }
.mr-5px{
  margin-right: 5px
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/DataTrailHistory.vue